import { EspecialidadeRequest } from './especialidade.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';

type EspecialidadeMap = {
    [ind in keyof EspecialidadeRequest]: EspecialidadeRequest[ind];
};

export function especialidadeMapper(especialidade: EspecialidadeMap): EspecialidadeRequest {
    return {
        registro: especialidade.registro,
        dsEspecialidade: especialidade.dsEspecialidade,
        idEspecialidade: especialidade.idEspecialidade,
        dsAreaAtuacao: especialidade.dsAreaAtuacao,
        idAreaAtuacao: especialidade.idAreaAtuacao,
        especialidIdEspecialidade: especialidade.especialidIdEspecialidade,
        medicoUfSgUf: especialidade.medicoUfSgUf,
        medicoIdSolicitante: especialidade.medicoIdSolicitante,
        nuRequerimentoEspecialidade: especialidade.nuRequerimentoEspecialidade,
        dtCancelamento: especialidade.dtCancelamento,
        dtEmissao: especialidade.dtEmissao,
        inPrincipal: especialidade.inPrincipal,
        nuFolhaRegistro: especialidade.nuFolhaRegistro,
        nuLivroRegistro: especialidade.nuLivroRegistro,
        dtCertificado: especialidade.dtCertificado,
        inReuniao: especialidade.inReuniao,
        nuReuniao: especialidade.nuReuniao,
        dtReuniao: especialidade.dtReuniao,
        txObsDocumento: especialidade.txObsDocumento,
        txObservacao: especialidade.txObservacao,
        nuRegistro: especialidade.nuRegistro,
        inPerito: especialidade.inPerito,
        idTpDocumento: especialidade.idTpDocumento,
        idResolucao: especialidade.idResolucao,
        resolucao: especialidade.resolucao,
        ufCurso: especialidade.ufCurso,
        inDivulga: especialidade.inDivulga,
        idDocumento: especialidade.idDocumento,
        idEspecArea: especialidade.idEspecArea
    };
}

export function especialidadeCreateFormToRequest(formPartial: Partial<EspecialidadeRequest>, pessoa: Pessoa): Partial<EspecialidadeRequest> {
    return {
        ...formPartial,
        medicoUfSgUf: pessoa.uf ?? '',
        medicoIdSolicitante: pessoa.id ?? 0
    };
}
